let cn = {
    CONFIRMDELETE: "请确认是否删除该记录？",
    CONFIRMSUBMIT: "请确认是否提交？"
};
let tw = {
    CONFIRMDELETE: "請確認是否刪除該記錄？",
    CONFIRMSUBMIT: "請確認是否提交？"
};
let en = {
    CONFIRMDELETE: 'Please confirm whether to delete the record?',
    CONFIRMSUBMIT: "Please confirm this is the final tender cost, once submitted, you are unable to change it"
}

export {
    cn,
    tw,
    en
}